import { createModule } from '../../createModule';
export const createPosmonAPI = createModule(({ http }) => {
    return {
        getSummary: async (params = {}) => {
            const res = await http.get('/v2/flow/posmon/summary', {
                params,
            });
            return res;
        },
        updateStructuredProduct: async (body) => {
            const res = await http.patch('/v2/flow/posmon/structured-product', { body: body });
            return res;
        },
        getSmartradeTrades: async (params) => {
            const res = await http.get('/v2/flow/posmon/tradeblotter', {
                params,
            });
            return res;
        },
        getSchedule: async (params) => {
            const res = await http.get('/v2/flow/posmon/schedule', { params });
            return res;
        },
        getSecondaryHistorical: async (params) => {
            const res = await http.get('/v2/flow/posmon/investment/secondary-historical', {
                params,
            });
            return res;
        },
        updateSecondaryHistorical: async (body) => {
            const res = await http.patch('/v2/flow/posmon/investment/secondary-historical', {
                body: body,
            });
            return res;
        },
        sendSecondaryEmail: async () => {
            const res = await http.post(`/v2/flow/posmon/send-secondary-email`);
            return res;
        },
    };
});
